<template>
  <div>
    <div class="masking"></div>
    <div :class="classes">
      <div :class="head">
        {{title}}
        <i
          @click="adClose"
          class="el-icon-close"
        ></i>
      </div>
      <div :class="body">
        <div
          v-if="showMasking"
          class="mask-face"
          @mousemove.stop.prevent="mousemove"
          @mousedown.stop.prevent="mousedown"
          @mouseup.stop.prevent="mouseup"
          @mouseleave.prevent="mouseup"
        ></div>
        <div
          v-if="!showMasking"
          ref="top"
          class="top-masking"
          @mousedown.stop.prevent="mousedown"
          @mouseup.stop.prevent="mouseup"
          @mousemove.stop.prevent="mousemove"
          @mouseleave.prevent="mouseup"
        ></div>
        <div
          v-if="!showMasking"
          class="bottom-masking"
          @mousedown.stop.prevent="mousedown"
          @mouseup.stop.prevent="mouseup"
          @mousemove.stop.prevent="mousemove"
          @mouseleave.prevent="mouseup"
        ></div>
        <canvas
          style="display:none"
          v-if="canvasNew"
          ref="can2"
        ></canvas>
        <div
          @mousemove.stop.prevent="mousemove"
          @mousedown.stop.prevent="mousedown"
          @mouseup.stop.prevent="mouseup"
          @mouseleave.prevent="mouseup"
        >
          <canvas
            ref="can"
            width="420"
            height="420"
          ></canvas>
        </div>
        <i
          class="el-icon-remove-outline"
          @click.stop="reduceProportion"
        ></i>
        <el-slider
          :class="slider"
          v-model="proportion"
          :show-tooltip="false"
        ></el-slider>
        <i
          class="el-icon-circle-plus-outline"
          @click.stop="addProportiond"
        ></i>
        <i
          class="fontFamily ryx-xuanzhuan"
          @click.stop="rotate"
        ></i>
        <P
          style="color:red;text-align: center;"
          v-if="showMasking"
        >请将人脸置于框内</P>
      </div>
      <div :class="btn">
        <el-button @click="adClose">取消</el-button>
        <!-- 新增保存 -->
        <el-button
          class="blue"
          type="primary"
          @click="Intercept"
        >保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
const classPrefix = `imgPopup`
const imgObj = new Image()
let rotate = 0
export default {
  props: {
    srcData: {
      type: String
    },
    showMasking: {
      type: Boolean
    },
    title: {
      type: String,
      default: '上传logo'
    },
    ImageType: {
      type: String,
      default: 'jpeg'
    },
    validateType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      proportion: 100,
      cxt: '',
      moveBool: false,
      startx: 0,
      starty: 0,
      xcha: 0,
      ycha: 0,
      clientX: 0,
      clientY: 0,
      canvasNew: true
    }
  },
  computed: {
    classes () {
      return classPrefix
    },
    head () {
      return `${classPrefix}-head`
    },
    body () {
      return `${classPrefix}-body`
    },
    slider () {
      return `${classPrefix}-slider`
    },
    btn () {
      return `${classPrefix}-btn`
    }
  },
  watch: {
    srcData (val) {
      if (val) {
        imgObj.src = val
      }
    },
    proportion (val) {
      this.cxt.clearRect(
        0,
        0,
        this.$refs.can.clientWidth,
        this.$refs.can.clientHeight
      )
      let client = this.getClient()
      if (rotate === 1 || rotate === 3) {
        this.cxt.drawImage(
          imgObj,
          client.clientY,
          client.clientX,
          imgObj.width * (this.proportion / 100),
          imgObj.height * (this.proportion / 100)
        )
      } else {
        this.cxt.drawImage(
          imgObj,
          client.clientX,
          client.clientY,
          imgObj.width * (this.proportion / 100),
          imgObj.height * (this.proportion / 100)
        )
      }
      // this.cxt.drawImage(
      //   imgObj,
      //   this.clientX,
      //   this.clientY,
      //   imgObj.width * (val / 100),
      //   imgObj.height * (val / 100)
      // )
    }
  },
  mounted () {
    this.cxt = this.$refs.can.getContext('2d')
    imgObj.onload = () => {
      if ((imgObj.width < 420 || imgObj.height < 420) && this.showMasking) {
        this.$message.error('原始图片尺寸不能小于420*420')
      }

      this.cxt.clearRect(
        0,
        0,
        this.$refs.can.clientWidth,
        this.$refs.can.clientHeight
      )
      if (rotate) {
        this.cxt.translate(420, 0)
        this.cxt.rotate(Math.PI / 2)
        this.cxt.drawImage(
          imgObj,
          0,
          0,
          imgObj.width * (this.proportion / 100),
          imgObj.height * (this.proportion / 100)
        )
        var context = this.$refs.can2.getContext('2d')
        context.translate(420, 0)
        context.rotate(Math.PI / 2)
        rotate = 0
      } else {
        this.cxt.drawImage(
          imgObj,
          0,
          0,
          imgObj.width * (this.proportion / 100),
          imgObj.height * (this.proportion / 100)
        )
      }
    }
  },
  methods: {
    adClose () {
      this.$emit('ad-change')
      Object.assign(this, {
        startx: 0,
        starty: 0,
        xcha: 0,
        ycha: 0,
        clientX: 0,
        clientY: 0,
        proportion: 100
      })
      this.cxt.clearRect(
        0,
        0,
        this.$refs.can.clientWidth,
        this.$refs.can.clientHeight
      )
      if (rotate) {
        for (let i = 0; i < rotate; i++) {
          this.cxt.translate(0, 420)
          this.cxt.rotate(-Math.PI / 2)
        }
        rotate = 0
      }
    },
    reduceProportion () {
      this.proportion--
    },
    addProportiond () {
      this.proportion++
    },
    mousedown (event) {
      if (event.button === 0) {
        this.moveBool = true
        this.startx = event.clientX
        this.starty = event.clientY
      }
    },
    mouseup () {
      if (event.button === 0) {
        this.moveBool = false;
        ({ clientX: this.clientX, clientY: this.clientY } = this.getClient())
        Object.assign(this, { startx: 0, starty: 0, xcha: 0, ycha: 0 })
      }
    },
    mousemove (event) {
      if (this.moveBool) {
        this.xcha = event.clientX - this.startx
        this.ycha = event.clientY - this.starty
        this.cxt.clearRect(
          0,
          0,
          this.$refs.can.clientWidth,
          this.$refs.can.clientHeight
        )
        let client = this.getClient()
        if (rotate === 1 || rotate === 3) {
          this.cxt.drawImage(
            imgObj,
            client.clientY,
            client.clientX,
            imgObj.width * (this.proportion / 100),
            imgObj.height * (this.proportion / 100)
          )
        } else {
          this.cxt.drawImage(
            imgObj,
            client.clientX,
            client.clientY,
            imgObj.width * (this.proportion / 100),
            imgObj.height * (this.proportion / 100)
          )
        }
      }
    },
    Intercept () {
      this.$refs.can2.width = this.$refs.can.clientWidth
      this.$refs.can2.height =
        this.$refs.can.clientHeight -
        2 * (this.$refs.top ? this.$refs.top.clientHeight : 0)
      var context = this.$refs.can2.getContext('2d')
      for (let i = 0; i < rotate; i++) {
        context.translate(420, 0)
        context.rotate(Math.PI / 2)
      }
      let client = this.getClient()
      if (rotate === 1 || rotate === 3) {
        context.drawImage(
          imgObj,
          client.clientY,
          client.clientX,
          imgObj.width * (this.proportion / 100),
          imgObj.height * (this.proportion / 100)
        )
      } else {
        context.drawImage(
          imgObj,
          client.clientX,
          client.clientY,
          imgObj.width * (this.proportion / 100),
          imgObj.height * (this.proportion / 100)
        )
      }
      var imageData = context.getImageData(
        0,
        0,
        this.$refs.can2.width,
        this.$refs.can2.height
      )
      for (var i = 0; i < imageData.data.length; i += 4) {
        // 当该像素是透明的，则设置成白色
        if (imageData.data[i + 3] === 0) {
          imageData.data[i] = 255
          imageData.data[i + 1] = 255
          imageData.data[i + 2] = 255
          imageData.data[i + 3] = 255
        }
      }
      context.putImageData(imageData, 0, 0)
      var url = this.$refs.can2.toDataURL(`image/${this.ImageType}`)
      this.save(url)
      this.adClose()
    },
    //  保存图片
    save (val) {
      val = val
        .replace('data:image/jpeg;base64,', '')
        .replace('data:image/png;base64,', '')
      if ((imgObj.width < 420 || imgObj.height < 420) && this.showMasking) {
        this.$message.error('上传失败，请上传高清图！')
        return false
      } else {
        let url =
          this.validateType === 1 ? `app/1.1/face/add` : `app/1.1/image/add`
        let params = this.validateType === 1 ? { face: val } : { image: val }
        this.$https
          .post(url, params, null, false)
          .then(res => {
            if (res.msg === '成功') {
              this.$message.success('图片上传成功')
              this.$emit(
                'intercept',
                res.data.faceId ? res.data.faceId : res.data.image
              )
            } else {
              // this.$emit('intercept', '22')
              this.$message.error(res.msg)
              this.adClose()
              this.$emit('intercept', '')
            }
          })
          .catch(_ => {
            this.$message.error(`图片上传失败，请重新上传`)
            this.adClose()
            this.$emit('intercept', '')
          })
      }
    },
    rotate () {
      let width =
        this.$refs.can.clientWidth > imgObj.width
          ? this.$refs.can.clientWidth
          : imgObj.width
      let height =
        this.$refs.can.clientHeight > imgObj.height
          ? this.$refs.can.clientHeight
          : imgObj.height
      this.cxt.clearRect(0, 0, width, height)
      this.cxt.translate(420, 0)
      this.cxt.rotate(Math.PI / 2)
      this.cxt.drawImage(
        imgObj,
        this.clientX,
        this.clientY,
        imgObj.width * (this.proportion / 100),
        imgObj.height * (this.proportion / 100)
      )
      rotate++
      rotate = rotate % 4
    },
    getClient () {
      let clientX
      let clientY
      if (rotate === 1) {
        clientX = this.clientX - this.xcha
        clientY = this.clientY + this.ycha
      } else if (rotate === 2) {
        clientX = this.clientX - this.xcha
        clientY = this.clientY - this.ycha
      } else if (rotate === 3) {
        clientX = this.clientX + this.xcha
        clientY = this.clientY - this.ycha
      } else {
        clientX = this.clientX + this.xcha
        clientY = this.clientY + this.ycha
      }
      return { clientX, clientY }
    }
  }
}
</script>

<style lang="less" scoped>
@prefixName: imgPopup;
.masking {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
}
.el-icon-close {
  float: right;
  font-size: 1.4rem;
  margin-top: 1.5rem;
  cursor: pointer;
}
.@{prefixName} {
  width: 444px;
  height: auto;
  background-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25rem 0 0 -17rem;
  z-index: 99;
  border-radius: 5px;
  &-head {
    height: 4rem;
    background-color: #6e9dd3;
    color: #ffffff;
    line-height: 4rem;
    padding: 0 1.5rem;
    font-size: 12px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &-body {
    padding: 1rem;
    position: relative;
    & > canvas {
      margin: 0 auto;
      user-select: none;
      cursor: -webkit-grab;
      cursor: grab;
    }
    & > i {
      font-size: 20px;
      line-height: 38px;
      color: tint(#606266, 30%);
      cursor: pointer;
      user-select: none;
      &:hover {
        color: #606266;
      }
    }
    & > .top-masking {
      width: 419px;
      height: 9.6rem;
      background-color: rgba(0, 0, 0, 0.4);
      position: absolute;
      left: 12px;
      user-select: none;
      top: 1rem;
      cursor: -webkit-grab;
      cursor: grab;
    }
    & > .bottom-masking {
      width: 419px;
      height: 9.6rem;
      background-color: rgba(0, 0, 0, 0.4);
      position: absolute;
      user-select: none;
      bottom: 50px;
      left: 12px;
      cursor: -webkit-grab;
      cursor: grab;
    }
    > .mask-face {
      position: absolute;
      user-select: none;
      left: 0;
      top: 0;
      width: 100%;
      height: 420px;
      background: url("/static/images/face.png") no-repeat center;
      margin: 1rem auto 0;
      cursor: -webkit-grab;
      cursor: grab;
    }
  }
  &-slider {
    width: 27rem;
    margin: 0 auto;
    display: inline-block;
    margin: 0 1rem;
    vertical-align: top;
  }
  &-btn {
    height: 7rem;
    text-align: right;
    padding: 1rem 2.5rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/setImg.vue